export default ({ app }, inject) => {
  inject("formatUrl", url => url.includes("http") ? url : `http://${url}`)
  inject("alphabetically", (a, b) => a === b ? 0 : a < b ? -1 : 1)
}
